import React, { useEffect, useState } from "react";
import classes from "./admin.module.css";
import BVAButton from "../BVAButton/BVAButton";
import Navbar from "../../pages/Dashboard/Navbar";
import ServerCall from "../../serverCall";
import toast from "react-hot-toast";

const AdminStripe = () => {
  const serverCall = ServerCall();
  const [stripeData, setStripeData] = useState({});
  const [editState, setEditState] = useState(false);
  const [productName, setProductName] = useState("");
  const [trialDays, setTrialDays] = useState(1);
  const [productPrice, setProductPrice] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const getStripeProduct = async () => {
    const response = await serverCall.customAxios.get("/get-stripe-product", {
      headers: {
        "Content-Type": "application/json",
      },
    });

    setStripeData(response?.data);
    setProductPrice(response?.data?.price?.unit_amount / 100);
    setProductName(response?.data?.product?.name);
    setProductDescription(response?.data?.product?.description);
    setTrialDays(response?.data?.product?.metadata?.trial_period_days);
  };
  const updateStripeProduct = async () => {
    try {
      setLoading(true);
      await serverCall.customAxios.patch(
        "/update-stripe-product",
        {
          productName: productName,
          productPrice: productPrice,
          productDescription: productDescription,
          trialDays: trialDays,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Updated Successfully.");
      setLoading(false);
    } catch (error) {
      toast.error("Unable to update.");
      setLoading(false);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!editState) {
      setEditState(true);
      return;
    }
    if (!productName || !productPrice) {
      toast.error("No blank field allowed!");
      return;
    }
    updateStripeProduct();
  };
  const handleChange = (e) => {
    e.target.name === "productName" && setProductName(e.target.value);
    e.target.name === "trialDays" && setTrialDays(e.target.value);
    e.target.name === "productPrice" && setProductPrice(e.target.value);
    e.target.name === "productDescription" &&
      setProductDescription(e.target.value);
  };
  useEffect(() => {
    getStripeProduct();
  }, []);
  return (
    <div>
      <Navbar />
      <div className={`${classes.formContainer}`}>
        <div className={`${classes.innerContainer}`}>
          <h1 className={classes.heading}>Stripe Subscription Product</h1>
          <form onSubmit={handleSubmit}>
            <div
              style={
                editState ? { gridTemplateColumns: "130px 1fr" } : undefined
              }
              className={`${classes.grid}`}
            >
              <label htmlFor="productPrice">
                <strong>Product Price:</strong>
              </label>
              {/* <p>Product.....</p> */}
              {!editState && (
                <p>${stripeData?.price?.unit_amount / 100 || "..."}</p>
              )}

              {editState && (
                <input
                  type="text"
                  id="productPrice"
                  name="productPrice"
                  value={productPrice}
                  placeholder="Product Price"
                  onChange={handleChange}
                  className={"input-error"}
                />
              )}
            </div>
            <div
              style={
                editState ? { gridTemplateColumns: "130px 1fr" } : undefined
              }
              className={`${classes.grid}`}
            >
              <label htmlFor="trialDays">
                <strong>
                  Trial Days: <br />
                  {editState && (
                    <span className={classes.font10}>
                      {" "}
                      (Enter 0 to remove trial period.)
                    </span>
                  )}
                </strong>
              </label>
              {/* <p>Product.....</p> */}
              {!editState && (
                <p>
                  {stripeData?.product?.metadata?.trial_period_days === "0"
                    ? "No Trial"
                    : stripeData?.product?.metadata?.trial_period_days || "..."}
                </p>
              )}

              {editState && (
                <input
                  type="number"
                  id="trialDays"
                  name="trialDays"
                  min={0}
                  max={10000}
                  value={trialDays}
                  placeholder="Trial Days"
                  onChange={handleChange}
                  className={"input-error"}
                />
              )}
            </div>
            <div
              style={
                editState ? { gridTemplateColumns: "130px 1fr" } : undefined
              }
              className={`${classes.grid}`}
            >
              <label htmlFor="productName">
                <strong>Product Name:</strong>
              </label>
              {!editState && <p>{stripeData?.product?.name || "..."}</p>}
              {editState && (
                <input
                  type="text"
                  id="productName"
                  name="productName"
                  value={productName}
                  placeholder="Product Name"
                  onChange={handleChange}
                  className={"input-error"}
                />
              )}
            </div>
            <div
              style={
                editState ? { gridTemplateColumns: "130px 1fr" } : undefined
              }
              className={`${classes.grid}`}
            >
              <label htmlFor="productDescription">
                <strong>Product Description:</strong>
              </label>
              {!editState && <p>{stripeData?.product?.description || "..."}</p>}
              {editState && (
                <textarea
                  rows={5}
                  cols={50}
                  id="productDescription"
                  name="productDescription"
                  value={productDescription}
                  placeholder="Product Description"
                  onChange={handleChange}
                  className={"input-error"}
                />
              )}
            </div>

            <div className="text-center flex justify-center gap-4 mt-8">
              {editState && (
                <BVAButton
                  onClick={() => {
                    setEditState(false);
                  }}
                  type="button"
                  kind="primary-outlined"
                  className={classes.cancelBtnWidth}
                >
                  {" "}
                  Cancel{" "}
                </BVAButton>
              )}
              <BVAButton loading={loading} type="submit" kind="primary">
                {!editState ? "Edit Details" : "Submit Product"}
              </BVAButton>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminStripe;
